import { Phone, MapPin, Navigation, Star, Instagram, Facebook } from "lucide-react";
import { BUSINESS, HOURS, dayHours } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-[#2A1B14] text-[#FDFBF7]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-16 sm:pt-20 pb-28 lg:pb-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-6">
            <span className="font-script text-3xl text-[#D4AF37]">
              Panificio · Caffetteria · Laboratorio
            </span>
            <h2 className="font-display font-light tracking-tight leading-[0.9] text-[clamp(3rem,9vw,7rem)] mt-2">
              di Laurie
            </h2>
            <a
              href={BUSINESS.reviewsUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#FDFBF7]/10 px-4 py-2 hover:bg-[#FDFBF7]/20 transition-colors duration-300"
              data-testid="footer-reviews-link"
            >
              <Star size={14} className="fill-[#D4AF37] text-[#D4AF37]" />
              <span className="font-body text-sm">
                {BUSINESS.rating} · {BUSINESS.reviewsCount} recensioni Google
              </span>
            </a>

            <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
              {BUSINESS.instagram && (
                <a
                  href={BUSINESS.instagram}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Seguici su Instagram"
                  className="grid place-items-center h-11 w-11 rounded-full border border-[#FDFBF7]/20 text-[#FDFBF7] hover:bg-[#D4AF37] hover:text-[#2A1B14] hover:border-[#D4AF37] transition-all duration-300"
                  data-testid="footer-instagram"
                >
                  <Instagram size={20} />
                </a>
              )}
              {BUSINESS.facebook && (
                <a
                  href={BUSINESS.facebook}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Seguici su Facebook"
                  className="grid place-items-center h-11 w-11 rounded-full border border-[#FDFBF7]/20 text-[#FDFBF7] hover:bg-[#D4AF37] hover:text-[#2A1B14] hover:border-[#D4AF37] transition-all duration-300"
                  data-testid="footer-facebook"
                >
                  <Facebook size={20} />
                </a>
              )}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-body text-xs tracking-[0.25em] uppercase text-[#FDFBF7]/50 mb-5">
              Contatti
            </h3>
            <ul className="space-y-4 font-body text-[#FDFBF7]/90">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#D4AF37] mt-0.5 shrink-0" />
                <span>
                  {BUSINESS.address}
                  <br />
                  {BUSINESS.city}
                </span>
              </li>
              <li>
                <a
                  href={BUSINESS.phoneHref}
                  className="flex items-center gap-3 link-underline"
                  data-testid="footer-phone"
                >
                  <Phone size={18} className="text-[#D4AF37]" />
                  {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS.mapsDir}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 link-underline"
                  data-testid="footer-directions"
                >
                  <Navigation size={18} className="text-[#D4AF37]" />
                  Indicazioni stradali
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-body text-xs tracking-[0.25em] uppercase text-[#FDFBF7]/50 mb-5">
              Orari
            </h3>
            <ul className="space-y-2 font-body text-sm">
              {HOURS.map((h) => (
                <li key={h.day} className="flex justify-between gap-4 text-[#FDFBF7]/85">
                  <span>{h.day}</span>
                  <span className={`text-right ${h.slots.length ? "" : "text-[#D4AF37]"}`}>
                    {dayHours(h)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FDFBF7]/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-[#FDFBF7]/50 text-center sm:text-left">
            © {new Date().getFullYear()} {BUSINESS.name}. Consumazione sul posto
            e asporto.
          </p>
          <a
            href={BUSINESS.phoneHref}
            className="font-body text-xs text-[#FDFBF7]/70 link-underline"
          >
            Ordina · Prenota
          </a>
        </div>
      </div>
    </footer>
  );
}
